module.exports = "235d9314610d1b4b38dc8d1cd43de828.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/spike-edge-mid.png
// module id = 48
// module chunks = 0